__turbopack_context__.v({
  "full": "Logo-module-scss-module__jRiYNq__full",
  "icon": "Logo-module-scss-module__jRiYNq__icon",
  "logo": "Logo-module-scss-module__jRiYNq__logo",
  "m": "Logo-module-scss-module__jRiYNq__m",
  "xs": "Logo-module-scss-module__jRiYNq__xs",
});
